import { defineMessages } from 'react-intl';

export const engravingInputMessages = defineMessages({
  cardHeadline: {
    id: 'engraving.card.headline',
    defaultMessage: 'Gravur',
  },
  label: {
    id: 'engraving.input.label',
    defaultMessage: 'Gravurtext',
  },
  placeholder: {
    id: 'engraving.input.placeholder',
    defaultMessage: 'Gib hier deine Wunschgravur ein',
  },
  maxLengthIndicator: {
    id: 'engraving.input.maxLengthIndicator',
    defaultMessage: '{length} / {maxlength} Zeichen',
  },
  moreInformationLink: {
    id: 'engraving.moreInformation.link',
    defaultMessage: 'Weitere Informationen zum Gravurservice',
  },
  moreInformationLinkClose: {
    id: 'engraengravingAndSerialNumberInputving.moreInformation.link.close',
    defaultMessage: 'Weniger Informationen anzeigen',
  },
  moreInformationP1: {
    id: 'engraving.moreInformation.p1',
    defaultMessage: 'Mit unserem gratis Gravur-Service wird der Artikel noch persönlicher.',
  },
  moreInformationP2: {
    id: 'engraving.moreInformation.p2',
    defaultMessage: 'Bitte benutze bei Bestickungen das Gravurtext Feld.',
  },
  moreInformationP3: {
    id: 'engraving.moreInformation.p3',
    defaultMessage:
      'Selbstverständlich ist auch die Nachgravur von ungravierten, bei uns gekauften Trauringen kostenlos. Einfach Ring und Gravur-Wunschkarte an die auf der beiliegenden Karte angegebenen Adresse einsenden.',
  },
  moreInformationP4: {
    id: 'engraving.moreInformation.p4',
    defaultMessage: 'Bitte beachte, dass gravierte Artikel vom Umtausch ausgeschlossen sind.',
  },
  errorMandatory: {
    id: 'engraving.input.error.mandatory',
    defaultMessage: 'Bitte gib deinen Gravurtext ein.',
  },
  errorgMaxLength: {
    id: 'engraving.error.maxLength',
    defaultMessage: 'Dein Gravurtext ist zu lang.',
  },
  informationP1: {
    id: 'engraving.information.p1',
    defaultMessage: 'Die Eingabe erfolgt in Großbuchstaben',
  },
  informationP2: {
    id: 'engraving.information.p2',
    defaultMessage: 'Umlaute müssen als AE, UE etc. geschrieben werden',
  },
  informationP3: {
    id: 'engraving.information.p3',
    defaultMessage: 'Deine Eingabe wird automatisch auf die benötigte Formatierung umgewandelt',
  },
  informationP4: {
    id: 'engraving.information.p4',
    defaultMessage: 'Du kannst Buchstaben, Zahlen, Punkte, Striche und Leerzeichen verwenden',
  },
  informationP5: {
    id: 'engraving.information.p5',
    defaultMessage:
      'Bei teilbaren Artikeln gib bitte beide Namen mit einem Bindestrich getrennt (z.B. PETER - PETRA) in das Formularfeld ein',
  },
});
